export default "__VITE_ASSET__WTt9MAPq__"